import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div(
  ({theme}) => css`
    display: grid;
    grid-template-rows: auto auto;
    border-radius: 5px;
    ${theme.elevations.large};
    overflow: hidden;

    ${theme.respondTo(
      'md',
      css`
        grid-template-rows: auto;
        grid-template-columns: 300px auto;
      `
    )}
  `
);
